import { CustomerSchema } from "@redotech/redo-customer-common/customer";
import * as z from "zod";

const CustomerSuggestionCandidateSchema_ = z.object({
  customer: CustomerSchema,
  score: z.number().min(0).max(1),
  matchReasons: z.array(z.string()),
});

export const CustomerSuggestionCandidateSchema: z.ZodType<CustomerSuggestionCandidate> =
  CustomerSuggestionCandidateSchema_;
export interface CustomerSuggestionCandidate extends z.infer<
  typeof CustomerSuggestionCandidateSchema_
> {}

export const getCustomerSuggestions = {
  name: "getCustomerSuggestions" as const,
  input: z.object({ conversationId: z.string() }),
  output: z.object({ suggestions: z.array(CustomerSuggestionCandidateSchema) }),
};
